export default {
    en: {
        router: {
            assetTypes: 'Types of devices',
        },
        shared: {
            asset: 'Device',
            assets: 'Devices',
        },
    },
    de: {
        router: {
            assetTypes: 'Typen von Geräte',
        },
        shared: {
            asset: 'Gerät',
            assets: 'Geräte',
        },
    },
    fr: {
        router: {
            assetTypes: 'Types de dispositifs',
        },
        shared: {
            asset: 'Dispositif',
            assets: 'Dispositifs',
        },
    },
    it: {
        router: {
            assetTypes: 'Tipi di dispositivi',
        },
        shared: {
            asset: 'Dispositivo',
            assets: 'Dispositivi',
        },
    },
}
